module.exports = __webpack_public_path__ + "img/maestros-de-la-parrilla-en-linea.806e996e.png";